import gql from 'graphql-tag';

export const ReactionsContentQuery = gql`
	query ReactionsContentQuery($contentId: ID!) {
		content(id: $contentId) {
			nodes {
				id
				contentReactionsSummary {
					reactionsCount
					ari
					containerAri
					reactionsSummaryForEmoji {
						emojiId
						count
						reacted
						id
					}
				}
			}
		}
	}
`;

export const ConfluenceReactionsContentQuery = gql`
	query ConfluenceReactionsContentQuery(
		$cloudId: ID!
		$contentId: ID!
		$contentType: GraphQLReactionContentType!
	) {
		confluence_contentReactionsSummary(
			cloudId: $cloudId
			contentType: $contentType
			contentId: $contentId
		) {
			contentReactionsSummary: reactionsSummary {
				reactionsCount
				ari
				containerAri
				reactionsSummaryForEmoji {
					emojiId
					count
					reacted
					id
				}
			}
		}
	}
`;
